
import React from "react";
import * as ReactRouterDom from "react-router-dom";
import { StringHelper } from "@rivtn/noseur";
import { i18nManager } from "../../i18n";
import { Utils } from "../../../../../utils";
import styles from "../../assets/style.module.css";

export interface SocialBandProps {
    socials: { [key: string]: string; };
}

function SocialBand({ socials }: SocialBandProps) {

    const labels = i18nManager.Labels.home;
    const entries = Object.entries(socials ?? {});

    if (!entries.length) return null;

    return (<div className={styles["social-band"]}>
        <div className={`${styles["container"]} ${styles["social-band-inner"]}`}>
            <div>
                <h2 className={styles["social-band-title"]}>{labels.socials_title}<br />{labels.socials_title_em}</h2>
                <p className={styles["social-band-desc"]}>{labels.socials_desc}</p>
            </div>
            <div className={styles["social-links"]}>
                {entries.map(([social, username]) => (
                    <ReactRouterDom.NavLink key={social} target="_blank" to={Utils.getSocialLink(social, username)} className={styles["social-link"]}>
                        <i className={Utils.getSocialIcon(social)} />
                        <span>{StringHelper.toSaneSentenceFormat(social)}</span>
                    </ReactRouterDom.NavLink>
                ))}
            </div>
        </div>
    </div>);
}

export default SocialBand;
